import { Hero } from '../../../components/index/Hero';

export const Page = () => {
  return (
    <>
      <Hero />
    </>
  );
};
